import React, { useState } from 'react';

import DateSelect from 'crm/elements/DateSelect';
import Card from 'crm/elements/common/Card';
import Row, { TableDetailsBody } from 'crm/elements/common/TableDetailsRow';
import { IS_CASINO_ENABLED } from 'crm/helpers/Constants';

function AffiliateStatistics({ url }: { readonly url: string }) {
    const [data, setData] = useState({
        ticketsCount: 0,
        ticketsSum: 0,
        ftd: 0,
        std: 0,
        stp: 0,
        depositsSum: 0,
        allDepositsCount: 0,
        confirmedDepositsCount: 0,
        depositsNotConfirmedCount: 0,
        registerCount: 0,
        avgUserValue: 0,
        avgReturningUserValue: 0,
        earning: null,
        lotteryEarning: null,
        casinoEarning: null,
    });

    return (
        <Card title="Affiliate statistics">
            <DateSelect
                url={`${url}/stats`}
                setData={setData}
                defaultRange={undefined}
                defaultStartDate={undefined}
                defaultEndDate={undefined}
                setStartDay={undefined}
                setEndDay={undefined}
                setIsLoading={undefined}
            />
            <TableDetailsBody>
                <Row label="Tickets">{data.ticketsCount}</Row>
                <Row label="Tickets sum">{data.ticketsSum}</Row>
                <Row label="FTD">{data.ftd}</Row>
                <Row label="STD">{data.std}</Row>
                <Row label="STP">{data.stp}</Row>
                <Row label="Deposits">{data.allDepositsCount}</Row>
                <Row label="Confirmed deposits">{data.confirmedDepositsCount}</Row>
                <Row label="Not confirmed deposits">{data.depositsNotConfirmedCount}</Row>
                <Row label="Deposit sum">{data.depositsSum}</Row>
                <Row label="Register count">{data.registerCount}</Row>
                <Row label="Average user value">{data.avgUserValue}</Row>
                <Row label="Average returning user value">{data.avgReturningUserValue}</Row>
                {data.earning && (
                    <>
                        <Row label="Affiliate earning">{data.earning}</Row>
                        {IS_CASINO_ENABLED && (
                            <>
                                <Row label="Affiliate lottery earning">{data.lotteryEarning}</Row>
                                <Row label="Affiliate casino earning">{data.casinoEarning}</Row>
                            </>
                        )}
                    </>
                )}
            </TableDetailsBody>
        </Card>
    );
}

export default AffiliateStatistics;
